import { Grid, TextField, Typography } from "@material-ui/core"
import { Autocomplete } from "@material-ui/lab"
import React, { useState } from "react"

export default function UpdateModelSettingsSection(props) {
  const { setMessageData, setValidated, releaseIds } = props
  const [acknowledge, setAcknowledge] = useState("")
  const [releaseId, setReleaseId] = useState(null)

  const reviewComponent = (acknowledgeValue, releaseIdValue) => {
    setReleaseId(releaseIdValue)
    setAcknowledge(acknowledgeValue)
    if (acknowledgeValue === "I Understand" && (releaseIdValue || releaseIdValue === 0)) {
      setValidated(true)
      setMessageData({
        releaseId: releaseIdValue,
      })
    } else {
      setValidated(false)
      setMessageData(null)
    }
  }

  return (
    <>
      <Grid item xs={12}>
        <Autocomplete
          onChange={(_, value) => reviewComponent(acknowledge, value)}
          value={releaseId}
          options={releaseIds}
          renderInput={(params) => <TextField {...params} label="Release ID" />}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography>
          Updating the model settings on the device to a release that contains settings for model
          files that do not exist on the device can cause problems. Reach out to Sentinel Support to
          confirm the correct release ID and acknowledge below.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          variant="outlined"
          rows={4}
          inputProps={{
            maxLength: 100,
          }}
          margin="dense"
          label='Write "I Understand"'
          name="Acknowledgement"
          value={acknowledge}
          onChange={(event) => reviewComponent(event.currentTarget.value, releaseId)}
        />
      </Grid>
    </>
  )
}
